import { Dexie } from 'dexie';
import { isServer } from '../../utils';
export const indexDBName = 'web-wallet-2';
export const indexDBVersion = 40;
export const dataBase = new (class Database extends Dexie {
    allTokenInfo;
    userAddressList; // user address book
    tokensAndNFTs; // tokensAndNFTs
    exchangeRate;
    balanceInfo;
    tansactionInfoList;
    customTokenList;
    nftMetadata;
    systemSetting;
    importTokenList;
    importNftList;
    constructor() {
        super(indexDBName);
        this.version(indexDBVersion).stores({
            allTokenInfo: '[chainType+chainId+chainName]',
            userAddressList: 'id,chainType,chainName,userAddress,walletAddress',
            tokensAndNFTs: 'id',
            exchangeRate: 'id',
            balanceInfo: 'id',
            tansactionInfoList: 'id',
            customTokenList: 'id,chainName,chainId,address,name,symbo',
            nftMetadata: 'id',
            systemSetting: 'userId',
            importTokenList: '[chainName+chainId+tokenAddress+chainNetwork+userAddress],chainName,chainId,tokenAddress,chainNetwork,userAddress,isSelected',
            importNftList: '[chainType+chainId+chainName+walletAddress+nftAddress+nftId],chainType,chainId,chainName,walletAddress,nftAddress,nftId',
        });
        this.open();
    }
    errorHandler(e) {
        (async () => {
            // @ts-ignore
            if (!isServer() && e?.message.includes('The user denied permission to access the database') && ((navigator.brave && (await navigator.brave.isBrave())) || false)) {
                // @ts-ignore
                window.__updateWebWalletData({ showBraveShieldModal: true });
            }
            else if (e?.name == 'DatabaseClosedError') {
                dataBase.open();
            }
            else if (e?.name == 'QuotaExceededError') {
                // QuotaExceededError may occur as the inner error of an AbortError
                console.error('QuotaExceeded error!');
            }
            console.log('dataBase error', e);
        })();
    }
})();
export default dataBase;
//# sourceMappingURL=database.js.map